import React from 'react';
import { ChangeSeriesBtn } from 'components/lib/buttons/IconButtons';
import styles from 'styles/components/lib/containers/seriesTitleContainer.css';

const SeriesTitleContainer = (props) => {
  let handleClick = (e) => {
    e.stopPropagation();
    props.handleClick();
  }
  let opacity = props.openMenu ? {opacity: 0, transition: 'all 0.3s ease'}
    : {opacity: 1, paddingLeft: '2px', transition: 'all 0.3s ease'};
  return (
    <div
      className={styles.seriesTitleContainer}
      style={props.openMenu ? {} : {height:'80px', width: '70%'}} >
      <h6 className={styles.seriesName}>{props.label}<span style={opacity}>|</span></h6>
      { !props.openMenu &&
        <ChangeSeriesBtn onClick={ handleClick } style={opacity} />
      }
    </div>
  )
}

export default SeriesTitleContainer;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/containers/SeriesTitleContainer.js